export const TabsSkeleton = () => (
  <div className="flex h-10 w-1/3 animate-pulse flex-row items-center gap-2 rounded-full bg-interface-neutral-2" />
);
